import React, { useContext } from "react";
import {
  Text,
  LegacyCard as Card,
  Collapsible,
  ColorPicker,
  Layout,
  InlineStack,
  TextField,
  BlockStack,
  Box,
} from "@shopify/polaris";

// import hoc
import { withErrorBoundary, withFeature } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

const Header = () => {
  const {
    color,
    errorMessage,
    handleChange,
    hex,
    // learnMore,
    resetDefault,
  } = useContext(BrandingContext);
  const { cms = () => {}, currentUser } = useContext(PrivateContext);
  const { updatedAt = "" } = currentUser || {};
  const { HEX, COLOR, HEADER, DEFAULT_HEADER_COLOR } = constant;

  return (
    <Collapsible open>
      <Layout.AnnotatedSection
        title={cms("section.headerColor.title")}
        description={cms("section.headerColor.description")}
      >
        <Card
          title={[
            cms("section.headerColor.title"),
            updatedAt && (
              <Text as="span" tone="subdued">
                <Text variant="bodySm" as="p">{`${baseHelper.lastUpdateDate(updatedAt)}`}</Text>
              </Text>
            ),
          ]}
          // actions={[{ content: "Learn more", onAction: () => learnMore(cms("section.headerColor.title"), "TODO: ") }]}
        >
          <Card.Section>
            <BlockStack gap="2">{cms("section.headerColor.subDescription")}</BlockStack>
            <br />
            <InlineStack align="space-between">
              <Box width="60%">
                <BlockStack>
                  <TextField
                    label={cms("section.headerColor.label.hexCode")}
                    value={hex.headerHex}
                    onChange={(value) => handleChange(HEADER, value, HEX)}
                    labelAction={
                      hex.headerHex !== DEFAULT_HEADER_COLOR && {
                        content: cms("label.reset"),
                        onClick: () => resetDefault(HEADER, DEFAULT_HEADER_COLOR, HEX),
                      }
                    }
                    error={errorMessage && errorMessage.header}
                  />
                  <br />
                  <Text as="span" variant="bodySm">
                    <div
                      style={{
                      borderRadius:".5rem",
                      width:"max-content",
                      height: "28px",
                      background: hex.headerHex,
                      color: hex.headerTextHex,
                      textAlign: "center",
                      padding: "6px 12px",
                    }}
                    >
                      {cms("section.headerColor.label.sampleHeader")}
                    </div>
                  </Text>
                </BlockStack>
              </Box>
              <ColorPicker onChange={(value) => handleChange(HEADER, value, COLOR)} color={color.header} />
            </InlineStack>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
    </Collapsible>
  );
};

export default withFeature(withErrorBoundary(Header), {
  feature: constant.STANDARD_BRANDING,
});
